import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";


function CheckboxIcon(props) {
	const {checked, classes} = props

	return (
		<i className={classnames({
			'fa fa-icon-checkbox-checked': checked,
			'far fa-icon-checkbox-not-checked': !checked,
		}) + " " + classes} />
	);
}

CheckboxIcon.propTypes = {
	checked: PropTypes.bool.isRequired,
	classes: PropTypes.string
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(CheckboxIcon);